import AnnualReportForm from "../../../model/AnnualReportForm";

const RECONFIRM_DATA_USAGE = `Please reconfirm that you intend to continue to use UK Biobank data to perform health-related research.`;
const HOW_WE_DEFINE_PUBLIC_HEALTH = `We define health-related research as any research which ultimately aims to improve human health.`;
const EXPLAIN_HOW_IS_HEALTH_RELATED = `Please explain how your proposed research is health-related, or why you are not sure.`;

/**
 * Props for this component
 */
interface PublicCodeUsageQuestionProps {
   form: AnnualReportForm,
   isLocked: boolean,
}

/**
 * Question regarding the intent to continue using UKB data for health related research.
 *
 * Used in: {@link ApplicantAnnualReportForm|Applicant annual report}
 * @param form An {@link AnnualReportForm} object with a saved report (Could be empty if it's a new report)
 * @param isLocked A boolean to indicate if the report is locked for editing or not
 */
export default function IntendToContinueUsingDataQuestion({form, isLocked}: PublicCodeUsageQuestionProps) {
   return (
      <div id="intentToUseDataQ" className="annual-report-question">
         <label id="intentToUseDataQMainText" className="question-text">{RECONFIRM_DATA_USAGE}</label>
         <span id="intentToUseDataQExtraInfo" className="extra-info">{HOW_WE_DEFINE_PUBLIC_HEALTH}</span>
         {isLocked ? (
            <span className="boolean-answer">{form.isHealthRelatedResearch ? 'YES' : 'NOT SURE'}</span>
         ) : (
            //Radio Button Area
            <div id="intentToUseDataQRadioArea" className="yes-or-no-radio">
               <input id="intentToUseDataQRadioYesInput" className="form-check-input" type="radio"
                      name="intentToUseDataQRadioSelection"
                      required
                      onChange={() => {
                         form.isHealthRelatedResearch = true;
                      }}
                      defaultChecked={(form.annualReportId && form.isHealthRelatedResearch != null) ? (form.isHealthRelatedResearch) : false}
               />
               <label id="intentToUseDataQRadioYesText" className="form-check-label"
                      htmlFor="intentToUseDataQRadioYesInput">
                  Yes
               </label>
               <input id="intentToUseDataQRadioNoInput" className="form-check-input" type="radio"
                      name="intentToUseDataQRadioSelection"
                      required
                      onChange={() => {
                         form.isHealthRelatedResearch = false;
                      }}
                      defaultChecked={(form.annualReportId && form.isHealthRelatedResearch != null) ? (!form.isHealthRelatedResearch) : false}
               />
               <label id="intentToUseDataQRadioNoText" className="form-check-label"
                      htmlFor="intentToUseDataQRadioNoInput">
                  Not Sure
               </label>
               <div id="intentToUseDataQRadioAreaFeedback" className="invalid-feedback">
                  Please select one option.
               </div>
            </div>
         )}
         {/*Text input area*/}

         <span id="intentToUseDataQReasoningText" className="annual-report-question">
               {EXPLAIN_HOW_IS_HEALTH_RELATED}
            </span>
         <textarea id="intentToUseDataQReasoningInput" name="lastYearResInput" className="form-control" rows={3}
                   disabled={isLocked}
                   onChange={(e) => form.healthRelatedResearchReasoning = encodeURIComponent(e.target.value)}
                   required minLength={100} maxLength={2000}>
         {decodeURIComponent(form.healthRelatedResearchReasoning ? form.healthRelatedResearchReasoning : '')}</textarea>
         <div id="lastYearResScopeFeedback" className="invalid-feedback">
            Your answer must have between 100 and 2000 characters.
         </div>
      </div>
   );
}
